import { SearchModel } from './../search/model';
import { Component, Input, OnChanges, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { PagedResult } from '../../models/paging';
import { DragDropType } from '../../enums/drap-drop-type';
import { SearchComponent } from '../search/search.component';
import { MatButton } from '@angular/material/button';
import { DragDropDepartmentComponent } from './components/department-restriction-specific/drag-drop-department/drag-drop-department.component';
import { DragDropChargingUserComponent } from './components/chargin-user-specific/drag-drop-charging-user.component';
import { DragDropIdTagComponent } from './components/id-tag-specific/drag-drop-id-tag.component';

@Component({
  selector: 'adm-drag-drop-relation',
  templateUrl: './drag-drop-relation.component.html',
  styleUrls: ['./drag-drop-relation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    SearchComponent,
    CdkDropList,
    MatButton,
    DragDropDepartmentComponent,
    DragDropChargingUserComponent,
    DragDropIdTagComponent,
    CdkDrag,
  ],
})
export class DragDropRelationComponent implements OnChanges {
  @Input() dragDropType!: DragDropType;
  @Input() leftSideHeader = '';
  @Input() rightSideHeader = '';
  @Input() leftSideList!: PagedResult<any>;
  @Input() rightSideList: Array<any> = [];
  @Input() rightFilteredList?: Array<any>;
  @Input() element: any;
  @Input() title = '';

  @Output() dropEvent = new EventEmitter<CdkDragDrop<Array<any>>>();
  @Output() update = new EventEmitter();
  @Output() loadMore = new EventEmitter();
  @Output() searchEvent = new EventEmitter<string>();

  filteredList: Array<any> = [];
  searchModel: SearchModel = {};
  public noItemsShow = 0;

  ngOnChanges() {
    this.assignCopy();
    this.noItemsShow = this.leftSideList?.items?.length || 0;
    if (this.noItemsShow > this.leftSideList?.totalCount) {
      this.noItemsShow = this.leftSideList?.totalCount;
    }
  }

  drop(event: CdkDragDrop<Array<any>>) {
    if (event.previousContainer !== event.container) {
      this.dropEvent.emit(event);
    }
  }

  assignCopy() {
    this.filteredList = Object.assign([], this.leftSideList?.items);
  }

  onSearch(searchModel: SearchModel) {
    this.searchModel = searchModel;
    this.searchEvent.emit(this.searchModel.searchQuery);
  }

  onUpdate(event?: any) {
    this.update.emit(event);
  }

  onLoadMore() {
    this.loadMore.emit();
  }

  disabled() {
    if ((this.leftSideList?.pageIndex + 1) * this.leftSideList?.pageSize > this.leftSideList?.totalCount) {
      return true;
    }

    return false;
  }

  protected readonly DragDropType = DragDropType;
}
